import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import "../../../styles/home1.css";

const averageCostData = [
  { year: "2019", value: 1000 },
  { year: "2020", value: 2500 },
  { year: "2021", value: 3800 },
  { year: "2022", value: 1500 },
  { year: "2023", value: 4200 },
  { year: "2024", value: 6000 }
];

export default function AverageCostChart() {
  return (
    <div className="card shadow-sm border-0 h-100">
      <div className="card-body">

        <div className="d-flex justify-content-between mb-3">
          <h6 className="fw-bold mb-0">Average Cost</h6>
          <small className="text-muted">Yearly</small>
        </div>

        <div style={{ width:"100%", height:200 }}>
          <ResponsiveContainer>
            <AreaChart data={averageCostData}>

              <defs>
                <linearGradient id="colorCost" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#4caf50" stopOpacity={0.8}/>
                  <stop offset="95%" stopColor="#4caf50" stopOpacity={0}/>
                </linearGradient>
              </defs>

              <CartesianGrid strokeDasharray="3 3" opacity={0.3}/>
              <XAxis dataKey="year"/>
              <YAxis/>
              <Tooltip/>

              <Area
                type="monotone"
                dataKey="value"
                stroke="#4caf50"
                fillOpacity={1}
                fill="url(#colorCost)"
              />

            </AreaChart>
          </ResponsiveContainer>
        </div>

      </div>
    </div>
  );
}